import {Injectable} from '@angular/core';
import {ApiService} from './api.service';
import {map} from 'rxjs/operators';
import {WindowRefService} from './../window-ref.service';

const routes = {
    voucher: '/generate-mode-pay',
};
@Injectable({
    providedIn: 'root'
})
export class ModePayService {
    
    constructor(private apiService: ApiService, private winRef: WindowRefService) {
    }

    generatePayement(rUid: string, stepPay: Object, idetab: number = this.winRef.appConfigSite.idEtab) {
        let params = {rUid, etablissement: idetab, ...stepPay};
        //let params = {voucher: voucher, rooms: rooms, start: start, end: end, idetab: idetab};
        return this.apiService.post(routes.voucher, params)
            .pipe(map((res: any) => {
                return res
            }));
    }

}
